import { useState, useEffect } from "react";
import api, { apiErrorMsg, TIPOS_ORGAO, UFS } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";

const VAZIO = { nome: "", uf: "", tipo_orgao: "Câmara", cnpj: "", telefone: "", email_institucional: "", endereco: "" };

export const NovoOrgaoModal = ({ open, onClose, onCreated }) => {
  const [form, setForm] = useState(VAZIO);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setForm(VAZIO); }, [open]);
  const setF = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const municipal = ["Câmara", "Prefeitura"].includes(form.tipo_orgao);

  const salvar = async () => {
    if (!form.nome.trim() || !form.uf) { toast.error("Informe o nome e a UF"); return; }
    setBusy(true);
    try {
      const payload = Object.fromEntries(Object.entries(form).map(([k, v]) => [k, v === "" ? null : v]));
      const { data } = await api.post("/municipios", payload);
      toast.success("Órgão criado na sua carteira. Cadastre as pessoas e envie para o curso.");
      onCreated(data);
    } catch (e) {
      toast.error(apiErrorMsg(e, "Erro ao criar órgão"));
    } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-xl" data-testid="modal-novo-orgao">
        <DialogHeader><DialogTitle>Novo município / órgão</DialogTitle></DialogHeader>
        <div className="grid grid-cols-2 gap-3">
          <div className="col-span-2">
            <Label>Tipo de órgão *</Label>
            <Select value={form.tipo_orgao} onValueChange={(v) => setF("tipo_orgao", v)}>
              <SelectTrigger data-testid="novo-orgao-tipo"><SelectValue /></SelectTrigger>
              <SelectContent>
                {TIPOS_ORGAO.map((t) => <SelectItem key={t} value={t}>{t}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
          <div className="col-span-2 sm:col-span-1">
            <Label>{municipal ? "Município *" : "Nome completo do órgão *"}</Label>
            <Input value={form.nome} onChange={(e) => setF("nome", e.target.value)}
              placeholder={municipal ? "Ex.: Uberaba" : "Ex.: Tribunal de Contas do Estado de MG"}
              data-testid="novo-orgao-nome" />
          </div>
          <div className="col-span-2 sm:col-span-1">
            <Label>UF *</Label>
            <Select value={form.uf} onValueChange={(v) => setF("uf", v)}>
              <SelectTrigger data-testid="novo-orgao-uf"><SelectValue placeholder="Selecione..." /></SelectTrigger>
              <SelectContent className="max-h-64">
                {UFS.map((u) => <SelectItem key={u} value={u}>{u}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
          <div><Label>CNPJ</Label><Input value={form.cnpj} onChange={(e) => setF("cnpj", e.target.value)} data-testid="novo-orgao-cnpj" /></div>
          <div><Label>Telefone</Label><Input value={form.telefone} onChange={(e) => setF("telefone", e.target.value)} data-testid="novo-orgao-telefone" /></div>
          <div className="col-span-2"><Label>E-mail institucional</Label><Input type="email" value={form.email_institucional} onChange={(e) => setF("email_institucional", e.target.value)} data-testid="novo-orgao-email" /></div>
          <div className="col-span-2"><Label>Endereço</Label><Input value={form.endereco} onChange={(e) => setF("endereco", e.target.value)} data-testid="novo-orgao-endereco" /></div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancelar</Button>
          <Button onClick={salvar} disabled={busy} className="bg-emerald-600 hover:bg-emerald-700" data-testid="btn-salvar-novo-orgao">
            {busy ? "Criando..." : "Criar órgão"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
